import { Box, Button } from "@outschool/backpack";
import { SignupModalQuery } from "@outschool/gql-frontend-generated";
import { faGift } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { joinParentAccountPath } from "@outschool/routes";
import { useConfetti } from "@outschool/ui-components-classroom";
import { UserHeadshotImage } from "@outschool/ui-components-shared";
import { Icon } from "@outschool/ui-legacy-component-library";
import { useLinkComponent } from "@outschool/ui-utils";
import { trim } from "lodash";
import React, { useEffect } from "react";
import { Trans } from "react-i18next";

export const SignupReferralModalContents = ({
  referrer,
  onClickExplore,
  onClickSignup
}: {
  referrer: SignupModalQuery["referrer"];
  onClickExplore: () => void;
  onClickSignup: () => void;
}) => {
  const { t } = useTranslation("client\\components\\SignupReferralModal");
  const Link = useLinkComponent();
  return (
    <Box
      flex
      sx={{
        flexFlow: "column",
        gap: "0.5em"
      }}
    >
      <ReferrerHeader referrer={referrer} />
      <Button
        variant="contained"
        component={Link}
        to={joinParentAccountPath()}
        onClick={onClickSignup}
      >
        {t("Sign Up & Claim")}
      </Button>
      <Button onClick={onClickExplore}>{t("Explore Classes First")}</Button>
    </Box>
  );
};

const ReferrerHeader = ({
  referrer
}: {
  referrer: SignupModalQuery["referrer"];
}) => {
  const { t } = useTranslation("client\\components\\SignupReferralModal");
  const referrerProfile = referrer?.leader?.approved
    ? referrer.leader
    : // @ts-ignore TS(2531): Object is possibly 'null'.
      referrer.parent;

  const { confettiCannon, fireConfetti } = useConfetti(confettiOptions);
  useEffect(() => {
    setTimeout(fireConfetti, 750);
  }, [fireConfetti]);

  return (
    <Box
      data-test-id="signup-modal-referral-header"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      {confettiCannon}
      {/* @ts-ignore TS(2531): Object is possibly 'null'. */}
      {referrerProfile.photo && !referrerProfile.socialOptOut ? (
        <UserHeadshotImage
          data-test-id="referrer-avatar"
          // @ts-ignore TS(2322): Type '{ __typename?: "Leader" | undefined; uid: st... Remove this comment to see the full error message
          user={referrerProfile}
        />
      ) : (
        <Icon icon={faGift} size={80} color="primary" />
      )}
      <Box
        data-test-id="referrer-message"
        sx={{
          marginBottom: "1em",
          marginTop: "1em",
          textAlign: "center",
          fontWeight: "fontWeightBold"
        }}
      >
        {/* @ts-ignore TS(2531): Object is possibly 'null'. */}
        {referrerProfile.socialOptOut ? (
          <Trans t={t}>
            You got{" "}
            <Box
              component="span"
              sx={{
                fontSize: "1.5em"
              }}
            >
              $20
            </Box>{" "}
            Outschool credit from your friend
          </Trans>
        ) : (
          <Trans t={t}>
            You got{" "}
            <Box
              component="span"
              sx={{
                fontSize: "1.5em"
              }}
            >
              $20
            </Box>{" "}
            {/* @ts-ignore TS(2531): Object is possibly 'null'. */}
            Outschool credit from {{ referrerName: trim(referrerProfile.name) }}
          </Trans>
        )}
      </Box>
    </Box>
  );
};

const confettiOptions = {
  angle: 90,
  spread: 180,
  startVelocity: 25,
  elementCount: 50
};
